import React, { useState, useEffect, useRef } from 'react';
import { X, Lightbulb, Sparkles } from 'lucide-react';

const ContextualCoach = ({
  isVisible,
  message,
  type = 'suggestion', // 'suggestion', 'encouragement', 'warning'
  onApply,
  onDismiss,
  onIgnore,
  autoDismissTime = 8000
}) => {
  const [isShowing, setIsShowing] = useState(false);
  const dismissTimerRef = useRef(null);

  useEffect(() => {
    if (isVisible && message) {
      setIsShowing(true);
      
      // Clear any existing timer
      if (dismissTimerRef.current) {
        clearTimeout(dismissTimerRef.current);
      }
      
      // Set auto-dismiss timer
      const dismissTime = type === 'encouragement' ? 12000 : autoDismissTime;
      dismissTimerRef.current = setTimeout(() => {
        handleDismiss();
      }, dismissTime);
    } else {
      setIsShowing(false);
    }
    
    return () => {
      if (dismissTimerRef.current) {
        clearTimeout(dismissTimerRef.current);
      }
    };
  }, [isVisible, message, type, autoDismissTime]);

  const handleDismiss = () => {
    setIsShowing(false);
    if (dismissTimerRef.current) {
      clearTimeout(dismissTimerRef.current);
    }
    if (onDismiss) {
      onDismiss();
    }
  };

  const handleApply = () => {
    handleDismiss();
    if (onApply) {
      onApply();
    }
  };

  const handleIgnore = () => {
    handleDismiss();
    if (onIgnore) {
      onIgnore();
    }
  };

  if (!isShowing) return null;

  const getCoachIcon = () => {
    switch (type) {
      case 'warning':
        return '⚠';
      case 'encouragement':
        return '✨';
      default:
        return '💡';
    }
  };

  return (
    <div className={`contextual-coaching ${isShowing ? 'show' : ''}`}>
      <div className="coaching-content">
        <div className="coach-avatar-small">
          {getCoachIcon()}
        </div>
        
        <div className="coaching-message">
          {message}
        </div>
        
        <div className="coaching-actions">
          {onApply && (
            <button 
              className="coaching-btn coaching-btn-primary"
              onClick={handleApply}
            >
              Apply suggestion
            </button>
          )}
          
          <button 
            className="coaching-btn coaching-btn-secondary"
            onClick={handleIgnore}
          >
            Not now
          </button>
        </div>
        
        <button 
          className="dismiss-coaching"
          onClick={handleDismiss}
          aria-label="Dismiss coaching"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default ContextualCoach;